import { render, staticRenderFns } from "./customerlist.vue?vue&type=template&id=606dff32&"
import script from "./customerlist.vue?vue&type=script&lang=js&"
export * from "./customerlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports